import axios from 'axios';
import queryString from 'query-string';
import { API_URL } from '../config';
import {
  convertOncoCareContractToApiFormat,
  bindOncoCareContractAndSaveInLocal,
} from '../helpers/oncoCare/oncoCareContractHelpers';

export const requestPrices = async (payload) => axios
  .post(`${API_URL}/price/oncoCare`, payload)
  .then((response) => response.data.result);

// @TODO use contractApi.js method using new mobile api
export const fetchRiskAmount = async () => axios
  .get(`${API_URL}/oncoCare/risk-amounts`)
  .then((response) => response.data.result);

export const createOncoCareDraft = async (data) => {
  const payload = convertOncoCareContractToApiFormat(data);
  return axios.post(`${API_URL}/draft-contract/oncoCare`, payload).then((res) => res.data);
};

export const updateOncoCareDraft = async (data) => {
  const payload = convertOncoCareContractToApiFormat(data);

  return axios.put(`${API_URL}/draft-contract/oncoCare/${data.draftId}`, payload).then((res) => res.data);
};

export const getOncoCareDraftContractByTokenRequest = async (id, token) => {
  const queryParams = { id, token };
  const URL = `${API_URL}/draft-contract/oncoCare?${queryString.stringify(queryParams)}`;
  return axios(URL, {
    method: 'GET',
  }).then((response) => bindOncoCareContractAndSaveInLocal(response.data));
};

export const saveOncoCareContractInCacheRequest = async (data) => {
  const payload = convertOncoCareContractToApiFormat(data);
  return axios.post(`${API_URL}/cache`, payload).then((res) => res.data);
};
